<template>
  <div class="all">
    <div class="nav-pc">
      <div class="title">
        <img src="@/static/img/xlx_edge_icon.svg" />
        {{ title }}
      </div>
    </div>
    <div class="center-pc">
      <div v-if="tripType == 'hotel'" class="list">
        <div class="centerItem">
          <label class="name">酒店类型*</label>
          <div class="radio-box">
            <label v-for="(item, index) in hotelOp"
              :key="index"
              ><input
                class="radio_dot"
                type="radio"
                name="hotelTypeRadio"
                :value="item.val"
                v-model="formData.hotelLevel"
                :disabled="$route.query.type=='view'"
              />{{ item.label }}</label
            >
          </div>
        </div>
        <div class="centerItem">
          <label class="name">入住时间*</label>
          <el-date-picker
            v-model="formData.checkinTime"
            class="set-el"
            type="date"
            placeholder="入住时间"
            value-format="timestamp"
            prefix-icon="none"
            :clearable="false"
            :readonly="$route.query.type=='view'"
          >
          </el-date-picker>
          <span style="margin:0 10px;">---</span>
          <el-date-picker
            v-model="formData.leaveTime"
            class="set-el"
            type="date"
            placeholder="离开时间"
            value-format="timestamp"
            prefix-icon="none"
            :clearable="false"
            :readonly="$route.query.type=='view'"
          >
          </el-date-picker>
        </div>
        <div class="centerItem">
          <label class="name">入住房型*</label>
          <div class="radio-box">
            <label v-for="(item, index) in roomOp"
              :key="index"
              ><input
                class="radio_dot"
                type="radio"
                name="roomTypeRadio"
                :value="item.val"
                v-model="formData.roomTypeId"
                :disabled="$route.query.type=='view'"
              />{{ item.label }}</label
            >
          </div>
        </div>
        <div class="centerItem">
          <label class="name">数量*</label>
          <input
            id="roomCount"
            placeholder="请输入房间数（间）"
            class="txtin inputRequired"
            autocomplete="off"
            v-model="formData.roomCount"
            :readonly="$route.query.type=='view'"
          />
        </div>
        <div class="centerItem" style="align-items: baseline;">
          <label class="name">其他需求</label>
          <textarea
            class="txtArea"
            v-model="formData.remark"
            :readonly="$route.query.type=='view'"
          ></textarea>
        </div>
        <div v-if="formData.mainStatus && formData.mainStatus !=1 " class="centerItem">
          <label class="name">状态</label>
          <div style="font-size:18px;">{{ formData.mainStatus==0?'已取消':'已分配' }}</div>
        </div>
        <div v-if="formData.roomCalendars && formData.roomCalendars.length>0" class="centerItem">
          <label class="name">房间分配</label>
          <table class="declaration-view-table">
            <tr>
              <td>酒店名称</td>
              <td>房间类型</td>
              <td>房间数量</td>
              <td>入住时间</td>
            </tr>
            <tr
              v-for="(item, index) in formData.roomCalendars"
              :key="index">
              <td>{{ item.hotelName }}</td>
              <td>{{ item.roomType | optionsFilter('roomOp') }}</td>
              <td>{{ item.roomCount }}</td>
              <td>{{ item.liveDate | timeFilter('{y}-{m}-{d}') }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div v-else class="list">
        <template v-if="tripType!=='car'">
          <div class="centerItem">
            <label class="name">{{tripType=='pickUp' ? '来时班次' : '离时班次'}}*</label>
            <input
              v-model="formData.travelNumber"
              placeholder="请输入具体班次"
              class="txtin inputRequired"
              autocomplete="off"
            />
          </div>
        </template>
        <div v-else class="centerItem">
          <label class="name">车辆类型*</label>
          <div class="radio-box">
            <label v-for="(item, index) in carTypeOp"
              :key="index"
              ><input
                class="radio_dot"
                type="radio"
                name="carTypeRadio"
                :value="item.val"
                v-model="formData.requireCarType"
              />{{ item.label }}</label
            >
          </div>
        </div>

        <template v-if="tripType=='pickUp'">
          <div class="centerItem">
            <label class="name">到达时间*</label>
            <el-date-picker
              v-model="formData.departureTime"
              class="set-el"
              type="datetime"
              placeholder="到达时间"
              value-format="timestamp"
              prefix-icon="none"
              :clearable="false"
            >
            </el-date-picker>
          </div>
          <div class="centerItem">
            <label class="name">到达站点*</label>
            <select
              v-model="formData.departurePlace"
              class="inputRequired"
            >
              <option
              v-for="(item, index) in siteOp"
              :key="index"
              :value="item"
              >{{ item }}</option
              >
            </select>
          </div>
          <div class="centerItem">
            <label class="name">目的地*</label>
            <input
              v-model="formData.arrivalDestination"
              placeholder="请输入到厦门后前往的目的地"
              class="txtin inputRequired"
              autocomplete="off"
            />
          </div>
        </template>

        <template v-else>
          <div class="centerItem">
            <label class="name">离开时间*</label>
            <el-date-picker
              v-model="formData.arrivalTime"
              class="set-el"
              type="datetime"
              placeholder="离开时间"
              value-format="timestamp"
              prefix-icon="none"
              :clearable="false"
            >
            </el-date-picker>
          </div>
          <div class="centerItem">
            <label class="name">出发地*</label>
            <input
              v-model="formData.departurePlace"
              placeholder="请输入出发地"
              class="txtin inputRequired"
              autocomplete="off"
            />
          </div>
          <div v-if="tripType=='dropOff'" class="centerItem">
            <label class="name">离时站点*</label>
            <select
              v-if="tripType=='dropOff'"
              v-model="formData.arrivalDestination"
              class="inputRequired"
            >
              <option
              v-for="(item, index) in siteOp"
              :key="index"
              :value="item"
              >{{ item }}</option
              >
            </select>
          </div>
        </template>
        
        <div class="centerItem">
          <label class="name">联系人*</label>
          <input
            v-model="formData.guestContactName"
            placeholder="请输入联系人姓名"
            class="txtin inputRequired"
            autocomplete="off"
          />
        </div>
        <div class="centerItem">
          <label class="name">联系方式*</label>
          <input
            v-model="formData.guestContactMobile"
            placeholder="请输入联系方式"
            class="txtin inputRequired"
            autocomplete="off"
          />
        </div>
        <div class="centerItem">
          <label class="name">随员*</label>
          <input
            id="togetherCount"
            v-model="formData.togetherCount"
            placeholder="请输入随员（人）"
            class="txtin inputRequired"
            autocomplete="off"
          />
        </div>
        
        <template v-if="$route.query.type!=='add'">
          <div v-if="formData.receptionistId" class="centerItem">
            <label class="name">接待人员</label>
            <div style="font-size:18px;">{{ `${formData.receptionistName}，联系方式：${formData.receptionistMobile}` }}</div>
          </div>
          <div class="centerItem">
            <label class="name">行程安排</label>
            <table class="declaration-view-table">
              <tr>
                <td>车牌号</td>
                <td>车辆类型</td>
                <td>车辆品牌</td>
                <td>司机</td>
                <td>司机联系方式</td>
              </tr>
              <tr
                v-for="(item, index) in formData.allocations"
                :key="index">
                <td>{{ item.carNumber }}</td>
                <td>{{ item.carType }}</td>
                <td>{{ item.carBrand }}</td>
                <td>{{ item.driverName }}</td>
                <td>{{ item.driverMobile }}</td>
              </tr>
            </table>
          </div>
        </template>
      </div>
    </div>

    <div class="foo">
      <div v-if="$route.query.type=='view'" style="justify-content: center;">
        <button class="leftBtn" @click="goBack">返回</button>
      </div>
      <div v-else>
        <button class="leftBtn" @click="goBack">返回</button>
        <button class="rightBtn" @click="submit">确认</button>
      </div>
    </div>
  </div>
</template>

<script>
import { hotelDemand, carDemands } from "@/api/trip"
var that

export default {
  filters: {
    timeFilter: function(tsp, type) {
      try {
        if (!tsp || tsp.toString().length == 0) {
          return ''
        }

        return that.$parseTime(tsp, type)
      } catch (err) {
        return ''
      }
    },
    optionsFilter: function(val, objType) {
      let str
      for(let i=0; i<that[objType].length; i++) {
        if(val == that[objType][i].val) {
          str = that[objType][i].label
          break
        }
      }
      return str
    }
  },
  data() {
    return {
      title: '',
      tripType: '',
      hotelOp: [{
          label: '舒适型',
          val: '1'
      }, {
          label: '高档型',
          val: '2'
      }, {
          label: '豪华型',
          val: '3'
      }],
      roomOp: [{
          label: '大床房',
          val: '1'
      }, {
          label: '双床房',
          val: '2'
      }, {
          label: '行政套房',
          val: '3'
      }],
      carTypeOp: [{
          label: '舒适轿车',
          val: '1'
      }, {
          label: '豪华轿车',
          val: '2'
      }, {
          label: '商务车（7座）',
          val: '3'
      }, {
          label: '小巴（15座）',
          val: '4'
      }, {
          label: '大巴（20座）',
          val: '5'
      }],
      siteOp: ['厦门高崎国际机场T3', '厦门高崎国际机场T4', '厦门北站', '厦门站'],
      formData: {}
    }
  },
  beforeCreate() {
    that = this
  },
  created() {
    this.tripType = this.$route.params.tripType
    let str = ''
    switch(this.tripType) {
      case 'pickUp':
          str = '接机行程'
          this.formData = {
            travelNumber: '',
            departureTime: null,
            arrivalDestination: '',
            departurePlace: '',
            togetherCount: '',
            guestContactName: '',
            guestContactMobile: ''
          }
        break
      case 'dropOff':
          str = '送机行程'
          this.formData = {
            travelNumber: '',
            arrivalTime: null,
            arrivalDestination: '',
            departurePlace: '',
            togetherCount: '',
            guestContactName: '',
            guestContactMobile: ''
          }
        break
      case 'hotel':
          str = '酒店行程'
          this.formData = {
            hotelLevel: '1',
            checkinTime: null,
            leaveTime: null,
            roomTypeId: '1',
            roomCount: '',
            remark: ''
          }
        break
      case 'car':
          str = '用车需求'
          this.formData = {
            requireCarType: '1',
            arrivalTime: null,
            departurePlace: '',
            togetherCount: '',
            guestContactName: '',
            guestContactMobile: ''
          }
        break
    }
    this.title = (this.$route.query.type == 'edit' ? '编辑' : this.$route.query.type == 'view' ? '查看' :'添加') + str
    if(this.$route.query.type !== 'add') {
      this.getDetail(this.$route.query.id)
    }
  },
  watch: {

  },
    methods: {
      getDetail(id) {
        switch(this.tripType) {
          case 'hotel':
            hotelDemand.detail(id).then(res => {
              if(res && res.code == 200) {
                this.formData = res.data
              }
            })
            break
          default:
            carDemands.detail(id).then(res => {
              if(res && res.code == 200) {
                this.formData = res.data
              }
            })
            break
        }
      },
      goBack() {
          this.$router.push({
            name: 'trip_manage',
            query: {
                type: this.tripType
            }
          })
      },
      // 表单校验
      checkForm: function() {
        var len = $(".inputRequired").length
        for (var j = 0; j < len; j++) {
          const value = $(".inputRequired")
            .eq(j)
            .val()
          if (value == null || value == "") {
            this.$message("该项不能为空~")
            $(".inputRequired")
              .eq(j)
              .focus()
            return false
          }
        }

        switch(this.tripType) {
          case 'pickUp':
            if(!this.formData.departureTime) {
              this.$message("到达时间不能为空~")
              return false
            }
            if(!this.$isInt(this.formData.togetherCount)) {
              this.$message("随员只能输入整数");
              $("#togetherCount").focus();
              return false
            }
            break
          case 'dropOff':
          case 'car':
            if(!this.formData.arrivalTime) {
              this.$message("离开时间不能为空~")
              return false
            }
            if(!this.$isInt(this.formData.togetherCount)) {
              this.$message("随员只能输入整数");
              $("#togetherCount").focus();
              return false
            }
            break
          case 'hotel':
            if(!this.formData.checkinTime) {
              this.$message("入住时间不能为空~")
              return false
            }
            if(!this.formData.leaveTime) {
              this.$message("离开时间不能为空~")
              return false
            }
            if(this.formData.leaveTime < this.formData.checkinTime) {
              this.$message("离开时间不能早于入住时间~")
              return false
            }
            if(!this.$isInt(this.formData.roomCount)) {
              this.$message("数量只能输入整数");
              $("#roomCount").focus();
              return false
            }
            break
        }

        return true
      },
      submit() {
        if(!this.checkForm()) {
          return
        }
        this.$msgbox({
          title: "确认信息",
          message: "确认提交该行程？",
          showClose: false,
          showCancelButton: true,
          cancelButtonClass: "cancel-btn-color",
          confirmButtonClass: "btn-color",
          callback: async(action, instance) => {
            if (action == "confirm") {
              let res
              let params = {
                ...this.formData,
                mainId: this.$session.get("cmm").mainId
              }
              switch(this.tripType) {
                case 'pickUp':
                  res = await carDemands[this.$route.query.type](Object.assign({
                    demandType: '1'
                  }, params))
                  break
                case 'dropOff':
                  res = await carDemands[this.$route.query.type](Object.assign({
                    demandType: '2'
                  }, params))
                  break
                case 'hotel':
                  res = await hotelDemand[this.$route.query.type](params)
                  break
                case 'car':
                  res = await carDemands[this.$route.query.type](Object.assign({
                    demandType: '3'
                  }, params))
                  break
              }
              try {
                if(res && res.code == 200) {
                  this.$message.success(this.title +'成功')
                  this.goBack()
                } else {
                  this.$message.success(this.title +'失败')
                }
              } catch (error) {
                console.log(error)
              }
            }
          }
        })
      }
    }
};
</script>

<style src="../../../static/css/regist.css" scoped></style>
<style src="../../../static/css/infoCommon.css" scoped></style>

<style scoped>
.radio-box {
  color: #C1A17B;
  font-size: 18px;
}
.radio-box label {
  margin-right: 10px;
}
.declaration-view-table {
  margin: unset;
  width: 726.7px;
  border: 1px solid #d2d2d2;
}
.declaration-view-table td {
  border-bottom: 1px solid #d2d2d2;
  border-right: 1px solid #d2d2d2;
}
</style>
